module.exports = __webpack_public_path__ + "static/img/books-stack-of-three-red.e5ccdc14.svg";